<script setup>
import { ref, watch } from "vue";
import { Head, Link, useForm } from "@inertiajs/vue3";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VAlert from "@/Shared/VAlert.vue";
import VDevider from "@/Shared/VDevider.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VHeaderButtonInfo from "@/Shared/HeaderButton/VButtonInfo.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";

const props = defineProps({
    title: String,
    additional: Array,
    filters: Array,
    nationality: Object,
    menulist: Array,
    canView: Boolean,
    urlShow: String,
    urlUpdate: String,
    urlIndex: String,
});

const form = useForm({
    title: props.additional.nationality.title,
    _method: "PUT",
});

const breadcrumbs = [
    {
        url: props.additional.urlIndex,
        label: "Nationality",
    },
    {
        url: "#",
        label: "Edit",
    },
];

const submit = () => {
    form.post(props.additional.urlUpdate, {
        preserveScroll: true,
    });
};
</script>

<template>
    <Head>
        <title>Edit - Nationality Management</title>
    </Head>
    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="additional.urlIndex"
                        :filters="additional.filters ?? {}"
                    >
                        Edit Location
                    </VTitleWithBackLink>
                    <div class="btn-wrapper">
                        <VHeaderButtonInfo
                            v-if="additional.canView"
                            :href="additional.urlShow"
                        />
                    </div>
                </div>

                <VDevider />
                <VAlert />

                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="title"
                                label="Nationality"
                                type="text"
                                :error="form.errors.title"
                                v-model:value="form.title"
                            />
                        </div>
                    </div>

                    <div class="text-end">
                        <VButtonSubmit
                            type="submit"
                            :isProcessing="form.processing"
                        >
                            Submit
                        </VButtonSubmit>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
